import { h, Component } from 'preact';
import cx from 'classnames';

import style from './style.less';
import CardIcon from './icon';
import { getImageSrc, getPlaceholder, imageError } from '../../../lib/image';
import { getAssetType } from '../../../lib/utils';

import { RenderOnVisible } from '@cube/blocks';
import { trackingProvider, DIMENSION } from '@cube/track';
import callWith from '@os/call-with';

const HiddenImage = (imageRole, imageCategory) => (
	<img
		class={style.placeholderImage}
		src={getPlaceholder(imageRole, imageCategory)}
	/>
);

/** A generic image for cards
 *  @param {Object}  asset          the asset with the images
 *  @param {String}  [imageRole]    the role of the image to display
 *  @param {String}  [iconPosition] position of icon, topleft, centered, topright, bottomleft, bottomright
 *  @param {Boolean} [iconColor]    iconColor flag, disables color when false, otherwise brand primary will be used
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'CardImage'
})
export default class CardImage extends Component {

	render({ asset, imageRole, imageCategory, iconPosition='centered', iconColor, qeId, Overlay }) {
		let imageSrc = getImageSrc(asset.images, imageRole, true, imageCategory);
		if (!imageSrc) return;

		return (
			<RenderOnVisible fallback={<HiddenImage imageRole={imageRole} imageCategory={imageCategory} />}>
				<div class={style.overlayImage} qid={qeId + '-image'}>
					<img
						class={style.image}
						src={imageSrc}
						onError={callWith(imageError, imageRole, imageCategory, true)}
					/>
					{ iconPosition !== 'none' &&
						<CardIcon
							name={getAssetType(asset)}
							color={iconColor}
							class={cx(style.icon, style[iconPosition])}
							qeId={qeId + '-image'}
						/>
					}
					{ Overlay &&
						<Overlay />
					}
				</div>
			</RenderOnVisible>
		);
	}
}
